import { Component, OnInit } from '@angular/core';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { SubHeader } from '../../../../core/models/sub-header.model';

@Component({
    selector: 'app-permitting-reports',
    templateUrl: './permitting-reports.component.html',
    styleUrls: ['./permitting-reports.component.scss'],
    standalone: false
})
export class PermittingReportsComponent implements OnInit {
  subHeader: SubHeader = new SubHeader({
    title: "Permitting Reports",
    buttons: []
  });
  constructor(public subHeaderService: SubHeaderService) { }

  ngOnInit() {
    this.subHeaderService.updateSubHeader(this.subHeader);
  }

}
